/**
 * @author Milton Filho
 *
 * Visually-hidden link that becomes visible when focused. Lets keyboard users
 * jump past repetitive navigation straight to the main content.
 */
import React from 'react';
import { Box } from 'rebass';

interface Props {
  targetId: string;
  label?: string;
}

export const SkipLink = ({
  targetId,
  label = 'Skip to main content',
}: Props) => (
  <Box
    as="a"
    href={`#${targetId}`}
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      padding: '8px 12px',
      backgroundColor: 'white',
      color: 'black',
      textDecoration: 'none',
      fontWeight: 'bold',
      zIndex: 9999,
      transform: 'translateY(-150%)',
      transition: 'transform 0.15s ease',
      '&:focus': {
        transform: 'translateY(0)',
        outline: '2px solid currentColor',
      },
    }}>
    {label}
  </Box>
);
